/* Private */
function shortenName(user) {
	return user?.first_name[0];
}

/* Public */
const getUserFullName = (user = {}) => user.name || `${user.first_name ? user.first_name + ' ' : ''}${user.last_name || ''}`;
function getAvatarSrc(profile) {
	if (!profile) {
		return null;
	}
	const { google_avatar, avatar } = profile;
	return avatar ? avatar : google_avatar;
}

function getAvatarLetter(user, isShorten) {
	if (!user) {
		return '?';
	}
	if (isShorten) {
		return shortenName(user);
	}
	if (user.first_name?.length > 0 && user.last_name?.length > 0) {
		return user.first_name.charAt(0) + user.last_name.charAt(0);
	}
	return user.email.charAt(0);
}

function getShortenedName(user) {
	if (!user) {
		return '';
	}
	const { first_name: firstName, last_name: lastName } = user;
	if (firstName && lastName) {
		return firstName[0] + lastName[0];
	} else {
		return user.name?.[0] || '';
	}
}

const AppAvatarService = {
	getAvatarSrc,
	getAvatarLetter,
	getUserFullName,
	getShortenedName,
};

export default AppAvatarService;
